import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { OppmoteFormData } from '../hooks/useOppmoteForm';

interface OppmoteTimeInputProps {
  formData: OppmoteFormData;
  onFormDataChange: (data: Partial<OppmoteFormData>) => void;
}

export const OppmoteTimeInput: React.FC<OppmoteTimeInputProps> = ({
  formData,
  onFormDataChange,
}) => {
  return (
    <>
      <div>
        <Label htmlFor="tidspunkt-mode">Tidspunkt</Label>
        <Select
          value={formData.tidspunktMode}
          onValueChange={(value: 'minutterFør' | 'faktiskTid') =>
            onFormDataChange({ tidspunktMode: value })
          }
        >
          <SelectTrigger id="tidspunkt-mode">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="minutterFør">Tid før oppstart</SelectItem>
            <SelectItem value="faktiskTid">Faktisk tidspunkt</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {formData.tidspunktMode === 'minutterFør' ? (
        <div>
          <Label htmlFor="minutterFør">Minutter før start</Label>
          <Input
            id="minutterFør"
            type="number"
            min="0"
            value={formData.minutterFør}
            onChange={(e) =>
              onFormDataChange({ minutterFør: parseInt(e.target.value) || 0 })
            }
            required
          />
          <p className="text-sm text-muted-foreground mt-1">
            Eksempel: 30 minutter = oppmøte 30 min før produksjonsstart
          </p>
        </div>
      ) : (
        <div>
          <Label htmlFor="faktiskTid">Klokkeslett</Label>
          <Input
            id="faktiskTid"
            type="time"
            value={formData.faktiskTid}
            onChange={(e) => onFormDataChange({ faktiskTid: e.target.value })}
            required
          />
          <p className="text-sm text-muted-foreground mt-1">
            Eksempel: 10:45 = oppmøte kvart på elleve
          </p>
        </div>
      )}
    </>
  );
};

